'use client'
/***
 *
 * @file components/Card/index.tsx
 * @description Card component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import React, { ReactNode, useState } from "react";
// import "./Card.scss";

type T_Props = {
  children: ReactNode,
  id?: string,
  className?: string,
  customStyles?: any
}

/**
 * Description: It takes in children as props and renders them within the html div element inside the Card/ Column layout
 * 
 * @param param0 
 * @example Parameter breakup
 * ```
 *  param0: {
 *    children,          //children components to be rendered
 *    className: "",     //className passed via contentful
 *    customStyles: {},  //style object passed via contentful
 *    id: ""             
 *  }
 * ```
 * @example T_Props 
 * ```
 * type T_Props = {
 *     id?: string,           // optional
 *     children: ReactNode,  
 *     className?: string,    //optional
 *     customStyles?: any     //optional
 * }
 * ```
 * @returns an html that renders child components within an html div element as part of a Card component
 */

const Card = ({ children, ...props }: T_Props) => {
  const [struct, setStruct]: any = useState();

  return (
    <div id={props?.id || "cd"} className={`bp-card ${props?.className || ''}`} style={{ ...props?.customStyles }} data-testid="Card">
      {children}
    </div>
  );
};

export default Card;
